import { validateAllField } from '@/utils/validate_v2';

const initFormPageBSerial = () => {
    return {
        serial_prize: '',
        serial_code: ''
    };
};

const configFormPageBSerial = (configData = null) => {
    return {
        serial_prize: {
            error: false,
            messageCustom: true,
            errorCustomMess: '',
            errorField: configData ? configData.errorField : '必ず選択してください。',
            typesValidate: ['required']
        },
        serial_code: {
            classCustom: '',
            error: false,
            errorCustomMess: '',
            errorField: configData ? configData.errorField : '必ず入力してください。',
            messageCustom: true,
            typesValidate: ['required', 'max255']
        }
    };
};

const onHandleMapMessage = (field, config) => {
    const valueField = field?.toString()?.trim();
    let checkValid = true;
    for (const validateType of config.typesValidate) {
        switch (validateType) {
            case 'required':
                if (!valueField) {
                    config.error = true;
                    checkValid = false;
                    return false;
                }
                break;
        }
    }
    return checkValid;
};

const onHandleKeypatternFormB = (allForm, allConfig, resData) => {
    const arrSerialCode = resData.setting_serial_code?.serial_codes || [];
    const extensionInputSerialCode = resData.form_pages.page_input_serial_code.extension;
    if (allForm.serial_code.toString() && arrSerialCode.length > 0) {
        const errorSerial = arrSerialCode.some((item) => item.serial_code.toString().trim() === allForm.serial_code.toString().trim());
        if (!errorSerial) {
            allConfig.serial_code.error = !errorSerial;
            allConfig.serial_code.errorField = extensionInputSerialCode.error_text_no_suitable_data_to_input;
            return false;
        }
        return true;
    }
    allConfig.serial_code.errorField = '必ず入力してください。';
    return true;
};

const onValidateAllFieldPageB = (allForm, allConfig, dataRes) => {
    let checkAll = validateAllField(allForm, allConfig);
    for (const field in allForm) {
        allForm[field] = allForm[field].toString()?.trim();
        checkAll = onHandleMapMessage(allForm[field], allConfig[field]) && checkAll;
    }
    checkAll = onHandleKeypatternFormB(allForm, allConfig, dataRes) && checkAll;
    return checkAll;
};

export { initFormPageBSerial, configFormPageBSerial, onHandleMapMessage, onValidateAllFieldPageB, onHandleKeypatternFormB };
